<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                Add Company
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-row>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Company Name"
                                    v-model="companyData.name"
                                    :error-messages="companyNameErrors"
                                    required
                                    @input="$v.companyData.name.$touch()"
                                    @blur="$v.companyData.name.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Company Address"
                                    v-model="companyData.address"
                                    :error-messages="companyAddressErrors"
                                    required
                                    @input="$v.companyData.address.$touch()"
                                    @blur="$v.companyData.address.$touch()"
                            ></v-text-field>
                        </v-col>
                        <!--<v-col cols="12"
                        sm="6"
                               md="4"
                        >
                            <v-text-field
                                    label="Company Code"
                            ></v-text-field>
                        </v-col>-->
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-menu
                                    v-model="snackbar.dateMenu"
                                    :close-on-content-click="true"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="companyData.establishedYear"
                                            label=" Establishment Year"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                            :error-messages="companyEstablishedYearErrors"
                                            required
                                            @input="$v.companyData.establishedYear.$touch()"
                                            @blur="$v.companyData.establishedYear.$touch()"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                        v-model="companyData.establishedYear"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Email'"
                                    v-model="companyData.email"
                                    :error-messages="companyEmailErrors"
                                    required
                                    @input="$v.companyData.email.$touch()"
                                    @blur="$v.companyData.email.$touch()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Website'"
                                    v-model="companyData.website"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               sm="6"
                               md="4"
                        >
                            <v-text-field
                                    :label=" ' Phone Number'"
                                    v-model="companyData.phoneNumber"
                                    :error-messages="companyPhoneNumberErrors"
                                    required
                                    @input="$v.companyData.phoneNumber.$touch()"
                                    @blur="$v.companyData.phoneNumber.$touch()"
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12"
                         sm="6"
                                md="4"
                         >
                             <v-file-input
                                     show-size
                                     label="Logo"
                             ></v-file-input>
                         </v-col>-->
                        <!--<v-col cols="12"
                        sm="6"
                               md="4"
                        >
                            <v-file-input
                                    show-size
                                    label="Register Document"
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12"
                        sm="6"
                               md="4"
                        >
                            <v-file-input
                                    show-size
                                    label="Tax Clearance Document"
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12"
                        sm="6"
                               md="4"
                        >
                            <v-file-input
                                    show-size
                                    label="Vat Document"
                            ></v-file-input>
                        </v-col>-->

                        <v-col
                                cols="12"
                                sm="6"
                                md="4"
                        >
                            <v-switch
                                    class="col-sm-6 col-md-4"
                                    v-model="companyData.isActive"
                                    required
                                    label="Is Active?"
                                    clearable
                            ></v-switch>
                        </v-col>
                        <!--   <v-col cols="12" md="12" sm="12">
                               <v-textarea
                                       name="input-7-1"
                                       label="About us"
                                       value=""
                                       rows="2"
                               ></v-textarea>
                           </v-col>-->
                    </v-row>
                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
            <v-btn class="custom-save-button" @click="submit">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: "createCompanyForm",
        props: ["success"],
        computed: {
            companyAddressErrors() {
                const errors = [];
                if (!this.$v.companyData.address.$dirty) return errors;
                !this.$v.companyData.address.required &&
                errors.push("Company Address is required");
                return errors;
            },
            companyNameErrors() {
                const errors = [];
                if (!this.$v.companyData.name.$dirty) return errors;
                !this.$v.companyData.name.required &&
                errors.push("Company name is required.");
                return errors;
            },
            companyPhoneNumberErrors() {
                const errors = [];
                if (!this.$v.companyData.phoneNumber.$dirty) return errors;
                !this.$v.companyData.phoneNumber.required &&
                errors.push("Company Phone Number is required.");
                return errors;
            },
            companyEstablishedYearErrors() {
                const errors = [];
                if (!this.$v.companyData.establishedYear.$dirty) return errors;
                !this.$v.companyData.establishedYear.required &&
                errors.push("Company Establishment year is required.");
                return errors;
            },
            companyEmailErrors() {
                const errors = [];
                if (!this.$v.companyData.email.$dirty) return errors;
                !this.$v.companyData.email.required &&
                errors.push("Company Email is required.");
                return errors;
            },
        },
        data() {
            return {
                created: false,
                companyData: {},
                snackbar: {
                    dateMenu: false,
                    servicesData:{
                        data:{},
                        message:"",
                        color:""
                    },
                }
            };
        },
        created() {

        },
        validations: {
            companyData: {
                name: { required },
                email: { required },
                address: { required },

                establishedYear: { required },
                phoneNumber: { required },
            }
        },
        methods: {
            dialogueClose() {
                this.companyData = {};
                this.$emit("dialogueClose");
            },
            formResponse() {
                this.$emit("formResponse", this.snackbar.servicesData);
                this.dialogueClose();
            },
            submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    axios.post("Company/Create", this.companyData).then(response => {
                        if (response.data.success) {
                            this.snackbar.servicesData.data=response.data
                            this.snackbar.servicesData.message="Company added Successfully"
                            this.snackbar.servicesData.color="success"
                            this.formResponse()
                        }
                    }).catch(response=>{
                        this.snackbar.servicesData.data=response.data
                        this.snackbar.servicesData.message="Error Adding Company, Please Contact Admin"
                        this.snackbar.servicesData.color="error"
                        this.formResponse()
                    });
                }
            },
            clear() {
                this.$v.$reset();
                this.companyData = {};
            },
        }
    };
</script>

<style scoped>
</style>
